<svg xmlns="http://www.w3.org/2000/svg" width="8.306" height="19.55" viewBox="0 0 8.306 19.55">
  <path
    d="M0.701,0.701l6.974,9.074L0.701,18.848"
    fill="none"
    stroke="#8693ad"
    stroke-linecap="round"
    stroke-width="1"
  />
</svg>
